import { amplitudeService } from '@/models/amplitude-service.ts';
import debounce from 'lodash/debounce';
/**
 * Fires `[Frontend] Feature Gate Hit` when a freemium user encounters a locked
 * feature. Debounced so rapid re-renders / re-opens of the same paywall don't
 * spam Amplitude. Aggregation and ranking by `feature` happen on Amplitude's
 * side — we only emit the raw encounter.
 */
const track = debounce((feature) => {
    amplitudeService.trackEvent('[Frontend] Feature Gate Hit', { feature });
}, 1000, { leading: true, trailing: false });
export function trackFeatureGateHit(feature) {
    track(feature);
}
